<template>
  <div class="iconButton">
    <component :is="iconButtonType" @click="emit('buttonClick')">
      <SvgIcon :size="size" :name="iconName" :border="border" />
    </component>
  </div>
</template>

<script lang="ts" setup>
import '@material/web/iconbutton/filled-icon-button.js';
import '@material/web/iconbutton/filled-tonal-icon-button.js';
import '@material/web/iconbutton/icon-button.js';
import '@material/web/iconbutton/outlined-icon-button.js';
import SvgIcon from 'ewi-ui/components/1-atoms/Icon/SvgIcon';
import { SvgIconSize } from 'ewi-ui/components/1-atoms/Icon/SvgIcon/SvgIcon.vue';
import { IconBorder } from 'ewi-ui/components/2-molecules/RoundIcon/RoundIcon.vue';

import { computed } from 'vue';
import './IconButton.scss';

export type IconButtonType = 'filled' | 'filledTonal' | 'outlined' | 'default';

export interface IconButtonProps {
  title?: string;
  type: IconButtonType;
  iconName: string;
  size?: SvgIconSize;
  border?: IconBorder;
}

const props = withDefaults(defineProps<IconButtonProps>(), {
  title: 'Accordion Item',
  type: 'default',
  iconName: '',
  size: 'sm',
  border: 'none',
});

const iconButtonType = computed(() => {
  switch (props.type) {
    case 'filled':
      return 'md-filled-icon-button';
    case 'filledTonal':
      return 'md-filled-tonal-icon-button';
    case 'outlined':
      return 'md-outlined-icon-button';
    default:
      return 'md-icon-button';
  }
});

const emit = defineEmits<{
  (e: 'buttonClick'): void;
}>();
</script>
